import { render, staticRenderFns } from "./_user.form.vue?vue&type=template&id=489de86f&scoped=true&"
import script from "./_user.form.vue?vue&type=script&lang=js&"
export * from "./_user.form.vue?vue&type=script&lang=js&"
import style0 from "./_user.form.vue?vue&type=style&index=0&id=489de86f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489de86f",
  null
  
)

export default component.exports